export default {
  SELECTED_QUOTE_ID_LIST: 'selected_quote_id_list',
  CLEAR_QUOTE_ID_LIST: 'clear_quote_id_list',
  SELECTED_CONTRACT_DATA: 'selected_contract_data',
  UPDATE_CONTRACT_DATA: 'update_contract_data',
  CLEAR_CONTRACT_DATA: 'clear_contract_data',
};
